import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { X } from "lucide-react";
import { OrbitTimeline, OrbitEmptyState } from "@/components/orbit";
import { STATUS } from "./MappingTab";

const ACTION = { confirm: "Association confirmée", unmap: "Association retirée", ignore: "Marqué comme ignoré", conflict: "Conflit détecté" };
const fmt = d => d ? new Date(d).toLocaleString("fr-FR", { dateStyle: "short", timeStyle: "short" }) : "";

export default function HistoryDrawer({ row, onClose }) {
  const [items, setItems] = useState(null);
  useEffect(() => { api.get(`/integrations/inpulse/mapping/${row.id}/history`).then(r => setItems(r.data)).catch(() => setItems([])); }, [row.id]);
  return (
    <div className="fixed inset-0 z-[80] bg-[rgba(7,24,46,.45)] flex justify-end orbit-v2" onClick={onClose} data-testid="history-drawer">
      <div className="w-full max-w-md h-full bg-white flex flex-col" style={{ boxShadow: "-12px 0 40px rgba(7,24,46,.18)" }} onClick={e => e.stopPropagation()}>
        <div className="px-5 py-4 flex items-start justify-between" style={{ borderBottom: "1px solid var(--orbit-line)" }}>
          <div><div className="o-label">Historique du mapping</div><div className="o-section-title mt-0.5">{row.external_name}</div><div className="text-[11px] o-muted font-mono">{row.external_id}</div></div>
          <button onClick={onClose} className="w-8 h-8 grid place-items-center rounded-[6px] hover:bg-[var(--orbit-surface-2)]" data-testid="history-close"><X className="w-4 h-4" /></button>
        </div>
        <div className="p-5 overflow-auto flex-1">
          {items && items.length === 0 && <OrbitEmptyState title="Aucune modification" hint="Ce magasin n'a pas encore été associé." />}
          {items && items.length > 0 && <OrbitTimeline items={items.map(h => ({ key: h.id, color: h.action === "confirm" ? "green" : h.action === "conflict" ? "red" : "muted", content: (
            <div><div className="text-[12.5px] font-bold">{ACTION[h.action] || h.action}</div>
              <div className="text-[11.5px] o-muted">{h.old_store ? h.old_store.name : (STATUS[h.old_status]?.[0] || "non associé")} → <b className="text-[var(--orbit-text)]">{h.new_store ? h.new_store.name : (STATUS[h.new_status]?.[0] || "—")}</b></div>
              <div className="text-[11px] o-muted">{h.user_name} · {fmt(h.at)}{h.reason ? ` · ${h.reason}` : ""}</div></div>) }))} />}
        </div>
      </div>
    </div>
  );
}
